<template>
  <div id="sidenav-collapse-main" class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100">
    <ul class="navbar-nav">
      <!-- <li class="nav-item" :class="getRoute() === 'dashboards' ? 'active' : ''">
        <sidenav-collapse  class="font-weight-bold"  :collapse-ref="username" :nav-text="userName" :class="getRoute() === username ? 'active' : ''">
          <template #icon>
            <img src="../../assets/img/sample_user2.png" class="avatar" />
          </template>
          <template #list>
            <ul class="nav pe-0"> -->
              <!-- nav links -->

              <!-- <sidenav-item :to="{ name: 'Settings' }" mini-icon="S" text="Settings" /> -->
              <!-- <sidenav-item :to="`/#`" @click="logout" mini-icon="logout" text="Logout" class="ml-5"/>
            </ul>
          </template>
        </sidenav-collapse>
      </li> -->
      <!-- <li class="nav-item">
        <router-link class="nav-link" :to="`/receivingScan`" :class="getRoute() === 'wms-store' ? 'active' : ''">
          <i class="material-symbols-outlined text-white">store</i>
          <span class="sidenav-normal me-3 ms-3 ps-1 text-white text-white">
            Receiving Part
          </span>
        </router-link>
      </li> -->
      <li class="nav-item active" v-if="!poNotVisible.includes(username)">
        <!--target="_blank"-->
        <!-- <sidenav-collapse collapse-ref="partDashboard" nav-text="PO Management">
          <template #icon>
            <i class="material-symbols-outlined opacity-10">assignment</i>
          </template>
          <template #list>
            <ul class="nav pe-0">
              <sidenav-item refer="transactionList" :to="`/poOverview`" mini-icon="fact_check"
                text="PO Overview" :class="getRoute() === 'poOverview' ? 'active' : ''" />

            </ul>
          </template>
        </sidenav-collapse> -->

        <sidenav-collapse collapse-ref="partDashboard" class="font-weight-bold menu-title mt-4" nav-text="Order Management">
          <template #icon>
            <i class="material-symbols-outlined opacity-10">shopping_cart</i>
          </template>


          <template #list>
            <hr class="menu-divider" />

            <ul class="nav pe-0 ml-5 sub-menu">
              <sidenav-item refer="transactionList" :to="`/dailyDemand`" 
                text="Daily Demand" mini-icon="schedule" size = "Large" 
                :class="[
                  getRoute() === 'dailyDemand' ? 'active' : '',
                  selectedMenu === 'dailyDemand' ? 'selected-item' : ''
                ]"
                @click="selectMenu('dailyDemand')"
                />

            </ul>
            <ul class="nav pe-0 ml-5 sub-menu">
              <sidenav-item refer="transactionList" :to="`/orderStatus`" mini-icon="	assignment"
                text="Order Status"
                :class="[
                  getRoute() === 'orderStatus' ? 'active' : '',
                  selectedMenu === 'orderStatus' ? 'selected-item' : ''
                ]"
                @click="selectMenu('orderStatus')"
                />

            </ul>
            <ul class="nav pe-0 ml-5 sub-menu">
              <sidenav-item refer="transactionList" :to="`/invoiceIssuance`" mini-icon="	receipt_long"
                text="Invoice Issuance" 
                :class="[
                  getRoute() === 'invoiceIssuance' ? 'active' : '',
                  selectedMenu === 'invoiceIssuance' ? 'selected-item' : ''
                ]"
                @click="selectMenu('invoiceIssuance')"
                />

            </ul>
            <ul class="nav pe-0 ml-5 sub-menu">
              <sidenav-item refer="transactionList" :to="`/packingHistory`" mini-icon="inventory_2"
                text="Packing List History" 
                
                :class="[
                  getRoute() === 'packingHistory' ? 'active' : '',
                  selectedMenu === 'packingHistory' ? 'selected-item' : ''
                ]"
                @click="selectMenu('packingHistory')"
                />

            </ul>
            <ul class="nav pe-0 ml-5 sub-menu">
              <sidenav-item refer="transactionList" :to="`/supplyPerformance`" mini-icon="inventory"
                text="Supply Performance" 
                :class="[
                  getRoute() === 'supplyPerformance' ? 'active' : '',
                  selectedMenu === 'supplyPerformance' ? 'selected-item' : ''
                ]"
                @click="selectMenu('supplyPerformance')"
                />

            </ul>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item active" v-if="materialScanVisible.includes(username)">
        <sidenav-collapse collapse-ref="materialDashboard" class="font-weight-bold menu-title mt-4" nav-text="Material Management">
          <template #icon>
            <i class="material-symbols-outlined opacity-10">storage</i>
          </template>

          <template #list>
            <hr class="menu-divider" />

            <ul class="nav pe-0 ml-5 sub-menu">
              <sidenav-item refer="materialScan" :to="`/materialScan`" 
                text="Material Scan" mini-icon="barcode"
                :class="[
                  getRoute() === 'materialScan' ? 'active' : '',
                  selectedMenu === 'materialScan' ? 'selected-item' : ''
                ]"
                @click="selectMenu('materialScan')"
              />
            </ul>

            <ul class="nav pe-0 ml-5 sub-menu">
              <sidenav-item refer="scanHistory" :to="`/scanHistory`" 
                text="Scan History" mini-icon="history"
                :class="[
                  getRoute() === 'scanHistory' ? 'active' : '',
                  selectedMenu === 'scanHistory' ? 'selected-item' : ''
                ]"
                @click="selectMenu('scanHistory')"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>


      <!-- <sidenav-item refer="receivingParts" :to="`/wms-store`" :class="getRoute() === 'wms-store' ? 'active' : ''"
        mini-icon="store" text="Receiving Part" /> -->

      <!-- <li class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder text-white">
          APPLICATION
        </h6>
      </li> -->
      <!-- <li class="nav-item active">

        <sidenav-collapse collapse-ref="partDashboard" nav-text="Warehouse">
          <template #icon>
            <i class="material-symbols-outlined opacity-10">warehouse</i>
          </template>
          <template #list>
            <ul v-if="username=='admin'" class="nav pe-0">
              <sidenav-item refer="mainTransaction" :to="`/partDashboard`" mini-icon="align_items_stretch"
                text="Part Dashboard" :class="getRoute() === 'partDashboard' ? 'active' : ''" />
              <sidenav-item refer="transactionList" :to="`/warehouseDashboard`" mini-icon="inventory_2"
                text="Warehouse Dashboard" :class="getRoute() === 'warehouseDashboard' ? 'active' : ''" />

            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item active">

        <sidenav-collapse collapse-ref="transaction" nav-text="Transaction">
          <template #icon>
            <i class="material-symbols-outlined opacity-10">local_shipping</i>
          </template>
          <template #list>
            <ul class="nav pe-0">
              <sidenav-item v-if="username =='admin'" refer="mainTransaction" :to="`/mainTransaction`" mini-icon="request_quote"
                text="Transaction Request" :class="getRoute() === 'mainTransaction' ? 'active' : ''" />
              <sidenav-item refer="transactionList" :to="`/transactionRequest`" mini-icon="data_check"
                text="Transaction List" :class="getRoute() === 'transactionRequest' ? 'active' : ''" />

            </ul>
          </template>
        </sidenav-collapse>
      </li> -->

      <!-- <li class="nav-item active">
        <a class="nav-link" href="/wms-store" :class="getRoute() === 'wms-store' ? 'active' : ''">

          <span class="material-symbols-outlined opacity-10">warehouse</span>
          <span>&nbsp; Store System</span>


        </a>
      </li>

      <li class="nav-item" :class="getRoute() === 'dashboards' ? 'active' : ''">
        <sidenav-collapse collapse-ref="ecommerceExamples" nav-text="Ecommerce"
          :class="getRoute() === 'ecommerce' ? 'active' : ''">
          <template #icon>
            <i class="material-icons-round opacity-10">shopping_basket</i>
          </template>

        </sidenav-collapse>
      </li> -->



    </ul>
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCollapse from "./SidenavCollapse.vue";
// import SidenavCollapseItem from "./SidenavCollapseItem.vue";
import { mapState } from "vuex";
export default {
  name: "SidenavList",

  components: {
    SidenavItem,
    SidenavCollapse,
    // SidenavCollapseItem
  },
  data() {
    return {
      materialScanVisible: ['P0200', 'P0300', 'P1001', 'P1000', 'P2004'], // ✅ 신화, CNJ, 로지스올, 이화
      poNotVisible: [ 'P1001', 'P1000'],

      title: "Soft UI Dashboard PRO",
      controls: "dashboardsExamples",
      isActive: "active",
      selectedMenu: "", // 👉 현재 선택된 메뉴 key

    };
  },
  computed: {
    ...mapState({
      username: state => state.username,
      userName: state => state.userName
    })
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");

      return routeArr[1];
    },
    selectMenu(key) {
      this.selectedMenu = key;
    },
    async logout() {
      localStorage.removeItem('accessToken');

            // 로그아웃 로직
            await fetch('/api/logout', {
                method: 'POST',
                credentials: 'include', // 쿠키를 포함하기 위해 필요
            });
            // 로그아웃 후 로그인 페이지로 리다이렉션
            this.$router.push('/login');
        }
  }
};
</script>
<style scoped>

#sidenav-collapse-main {
  font-family: 'HyundaiSans' !important;
}
/* Order Management 밑에 구분선 */
::v-deep(.menu-divider) {
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2) !important;
  width: 90%;
  margin: 0px auto;
}

/* ✅ 하위 리스트 글자 크기 줄이기 */
.sub-menu {
  font-size: 14px !important; /* 글자 크기 줄이기 */
}
/* ✅ Order Management 글자 색상 변경 */
:deep(.menu-title) {
  color: #ffffff !important;
}

@font-face {
    font-family: 'HyundaiSans2';
    src: url('../../assets/fonts/HyundaiSansHeadKRMedium.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRLIGHT.TTF') format('truetype');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}
#sidenav-collapse-main {
  overflow-x: hidden !important;
}

.nav {
  overflow-x: hidden !important;
}


</style>